// extracted by mini-css-extract-plugin
export default {"Container":"SimpleCenteredLayout__Container__GlihA","ContentWrapper":"SimpleCenteredLayout__ContentWrapper__PyL-H"};